import { render, staticRenderFns } from "./QueenEdit.vue?vue&type=template&id=5f9b2650&"
import script from "./QueenEdit.vue?vue&type=script&lang=js&"
export * from "./QueenEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports